<template>

  <AbortStateTemplate
      :headline="headline"
      :message="abortMessage"
      :teaserCards="teaserCardsData"
  />
</template>

<script>
import teaserCardsData from "@/data/teaserDataBuldingType";
import AbortStateTemplate from "@/components/abortStates/AbortStateTemplate.vue";

export default {
  name: 'StateAbortBuildingType',
  components: {
    AbortStateTemplate,
  },
  data() {
    return {
      abortMessage:
          "Unser Angebot richtet sich nur an Eigentümer und Eigentümerinnen von Ein- oder Zweifamilienhäusern sowie von Reihenhäusern. Wir bauen unser Angebot aber zukünftig weiter aus.",
      teaserCardsData
    };
  },
}
</script>

<style scoped>

</style>
